import { render, staticRenderFns } from "./SavedCalculationsDialog.vue?vue&type=template&id=0f4fd56a&scoped=true"
import script from "./SavedCalculationsDialog.vue?vue&type=script&lang=js"
export * from "./SavedCalculationsDialog.vue?vue&type=script&lang=js"
import style0 from "./SavedCalculationsDialog.vue?vue&type=style&index=0&id=0f4fd56a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fd56a",
  null
  
)

export default component.exports